import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Row,
  Col,
  Input,
  Button,
} from "reactstrap";
import { FaTrash } from "react-icons/fa";
import axios from "../../../../utills/api";

const API_BASE = "/department";

const DepartmentModal = ({
  isOpen,
  toggle,
}) => {
  const [categories, setCategories] =
    useState([]);

  const [newCategory, setNewCategory] =
    useState("");

  const token =
    localStorage.getItem("token");

  const axiosConfig = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const fetchDepartmentCategories =
    async () => {
      try {
        const res = await axios.get(
          `${API_BASE}/department`,
          axiosConfig
        );

        setCategories(
          Array.isArray(res.data)
            ? res.data
            : []
        );
      } catch (err) {
        console.error(err);
      }
    };

  useEffect(() => {
    if (isOpen) {
      fetchDepartmentCategories();
    }
  }, [isOpen]);

  const handleCreateCategory =
    async () => {

      if (!newCategory.trim()) {
        return alert(
          "Please enter department name"
        );
      }

      try {

        const res =
          await axios.post(
            `${API_BASE}/department`,
            {
              name: newCategory.trim(),
            },
            axiosConfig
          );

        setCategories((prev) => [
          ...prev,
          res.data,
        ]);

        setNewCategory("");

      } catch (err) {

        console.error(err);

        alert(
          err.response?.data?.message ||
          "Unable to create department"
        );

      }

    };

  const handleDeleteCategory =
    async (id) => {

      if (
        !window.confirm(
          "Delete this department?"
        )
      ) {
        return;
      }

      try {

        await axios.delete(
          `${API_BASE}/department/${id}`,
          axiosConfig
        );

        setCategories((prev) =>
          prev.filter(
            (item) =>
              item._id !== id
          )
        );

      } catch (err) {

        console.error(err);

        alert(
          err.response?.data?.message ||
          "Unable to delete department"
        );

      }

    };

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      size="lg"
    >
      <ModalHeader toggle={toggle}>
        Manage Departments
      </ModalHeader>

      <ModalBody>

        {/* Create Department */}

        <div
          className="mb-4 p-3 rounded"
          style={{
            backgroundColor:
              "#f8f8f8",
          }}
        >
          <h6>
            Create Department
          </h6>

          <Row className="mt-2">

            <Col md={8}>
              <Input
                type="text"
                placeholder="Enter department name"
                value={newCategory}
                onChange={(e) =>
                  setNewCategory(
                    e.target.value
                  )
                }
              />
            </Col>

            <Col md={4}>
              <Button
                color="success"
                onClick={
                  handleCreateCategory
                }
              >
                Create Department
              </Button>
            </Col>

          </Row>
        </div>

        {/* Department List */}

        <div
          className="p-3 rounded"
          style={{
            backgroundColor:
              "#f8f8f8",
          }}
        >
          <h6>
            All Departments
          </h6>

          {categories.length === 0 ? (

            <p className="text-muted">
              No departments found
            </p>

          ) : (

            <Row
              className="mt-3"
              style={{
                rowGap: "15px",
              }}
            >
              {categories.map(
                (item) => (
                  <Col
                    key={item._id}
                    xs={12}
                    sm={6}
                    md={4}
                    lg={3}
                  >
                    <div
                      style={{
                        position:
                          "relative",
                      }}
                    >
                      <Input
                        value={
                          item.name
                        }
                        readOnly
                        style={{
                          paddingRight:
                            "30px",
                        }}
                      />

                      <FaTrash
                        style={{
                          position:
                            "absolute",
                          right: "10px",
                          top: "50%",
                          transform:
                            "translateY(-50%)",
                          color:
                            "#dc3545",
                          cursor:
                            "pointer",
                        }}
                        onClick={() =>
                          handleDeleteCategory(
                            item._id
                          )
                        }
                      />
                    </div>
                  </Col>
                )
              )}
            </Row>

          )}

        </div>

      </ModalBody>
    </Modal>
  );
};

export default DepartmentModal;